import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Marquee from '../components/Marquee';
import Services from '../components/Services';
import Cases from '../components/Cases';
import Process from '../components/Process';
import Pricing from '../components/Pricing';
import Testimonials from '../components/Testimonials';
import FAQ from '../components/FAQ';
import Contact from '../components/Contact';
import FinalCTA from '../components/FinalCTA';
import Footer from '../components/Footer';
import WhatsAppFloat from '../components/WhatsAppFloat';
import BlogSideRail from '../components/BlogSideRail';

export default function Home() {
  return (
    <main className="relative">
      <Header />
      <BlogSideRail />
      <Hero />
      <Marquee />
      <Services />
      <Cases />
      <Process />
      <Pricing />
      <Testimonials />
      <FAQ />
      <Contact />
      <FinalCTA />
      <Footer />
      <WhatsAppFloat />
    </main>
  );
}
